module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Circle-d5c0af97beeaebe7f6538ded7938b48280635a12f1028a487df725499ea32ea9.svg";